export default __webpack_public_path__ + "static/AnalyticsImage-4dc5f85fe03b36b747cc8faf3645d603.png";